const eventTypes = {
  'Athletic Event': { main: '#FADF08', contrast: '#616161' },
  'Club Event': { main: '#7b500fff', contrast: '#ffffff' },
  'Cultural / Community': { main: '#1AC8ED', contrast: '#ffecdb' },
  'Cycling Event': { main: '#9AD1D4', contrast: '#000000' },
  'Equestrian SJ': { main: '#00964C', contrast: '#ffecdb' },
  'Equestrian XC': { main: '#85276A', contrast: '#ffecdb' },
  'Equestrian Other': { main: '#F28B1F', contrast: '#ffecdb' },
  'Film & TV Production': { main: '#6C756B', contrast: '#ffffff' },
  'Live Music': { main: '#8744caff', contrast: '#ffffff' },
  'Motor Sports': { main: '#242F40', contrast: '#ffecdb' },
  'Music Festivals': { main: '#1AC8ED', contrast: '#ffecdb' },
  'Night-Time Economy': { main: '#5e0664ff', contrast: '#ffffff' },
  'Running Event': { main: '#27066eff', contrast: '#ffffff' },
  Sports: { main: '#08b1c1ff', contrast: '#ffffff' },
  'Ultra Marathon': { main: '#0d7a01ff', contrast: '#ffffff' },
  'Water Sports': { main: '#49475B', contrast: '#ffecdb' },
  Other: { main: '#160560ff', contrast: '#ffffff' },
}

export default eventTypes
